import axios from './axios';

export default class PathSection {
  static destroy(_, section, pathId) {
    return axios.delete(`/paths/sections/${section.id}?path_id=${pathId}`).then(response => response.data);
  }
}
